module.exports = __webpack_public_path__ + "static/consortium-gradient-e6b6d626c177dee0c8cd3dd5d7bc79c5.jpg";